module.exports = __webpack_public_path__ + "static/img/center_02.361541c4.png";